"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KetteOeffnungsausrichtung = void 0;
/**
 * Defines from which side a Kette can be opened for assembly.
 *
 * This information is more precise than the `KetteOeffnungsprinzipLabel`.
 * Always use this here for any kind of business logic.
 *
 * @deprecated use KetteOpeningPrinciple instead
 */
var KetteOeffnungsausrichtung;
(function (KetteOeffnungsausrichtung) {
    KetteOeffnungsausrichtung["Innen"] = "Innen";
    KetteOeffnungsausrichtung["Aussen"] = "Aussen";
    KetteOeffnungsausrichtung["Beidseitig"] = "Beidseitig";
    KetteOeffnungsausrichtung["Geschlossen"] = "Geschlossen";
})(KetteOeffnungsausrichtung = exports.KetteOeffnungsausrichtung || (exports.KetteOeffnungsausrichtung = {}));
//# sourceMappingURL=KetteOeffnungsausrichtung.js.map